module.exports = __webpack_public_path__ + "static/media/m24.58997156.jpg";